export default "__VITE_ASSET__CBBl_sa8__"